import { render, staticRenderFns } from "./KatalogCiKnopf.vue?vue&type=template&id=43d6a824&scoped=true"
import script from "./KatalogCiKnopf.vue?vue&type=script&lang=js"
export * from "./KatalogCiKnopf.vue?vue&type=script&lang=js"
import style0 from "./KatalogCiKnopf.vue?vue&type=style&index=0&id=43d6a824&prod&scoped=true&lang=css"
import style1 from "./KatalogCiKnopf.vue?vue&type=style&index=1&id=43d6a824&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d6a824",
  null
  
)

export default component.exports